import React from 'react';

const Dot = ({ color, padding = 'px-1', size = '12px', icon = 'fa-play',
               label = null, fontWeight='500' }) => {
  const style = {
    fontSize: size,
    color: color,
    marginRight: label ? '8px' : '0', // Add some space between the dot and the label if the label is present
  };
  const labelStyle = {
    fontFamily: 'var(--font-title)',
    fontWeight: fontWeight,
  }

  return (
    <span style={{ display: 'flex', alignItems: 'center' }}>
      <i className={`fa-solid ${icon} ${padding}`} style={style}></i>
      {label && <span style={{ fontSize: size, ...labelStyle }}>{label}</span>}
    </span>
  );
};

export default Dot;
